export const titleContent =
  "mobile:text-[1.3rem] ipadMin:text-[1.6rem] ipadMax:text-[2rem] laptop:text-[2.5rem] largeScreen:text-[3rem]";
export const textContent =
  "mobile:text-[1rem] ipadMin:text-[1.1rem] ipadMax:text-[1.2rem] laptop:text-[1.3rem] largeScreen:text-[1.5rem]";

export const bg_green_linear_color =
  "bg-[linear-gradient(270deg,_#15470F_0%,_#498801_96.04%)]";

export const green_color = "text-[#35751F]";
